<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6">
        is a consulting company providing services and technology solutions. We
        stand beside all businesses to help them shape and drive their
        transformation journey. We are always at the forefront of innovation.
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessInfo",

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "Kenwyn Consultancy Services PVT. <br> Ltd . No 20, <br> 2nd Lane Linganagar,<br> Trincomalee",
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+94-26 205 5830",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@myeduvisa.com",
      },
    ],
  }),
};
</script>
